var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#242424;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-34 -1023)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3,1A2,2,0,0,0,1,3v9a2,2,0,0,0,2,2H16a2,2,0,0,0,2-2V3a2,2,0,0,0-2-2H3M3,0H16a3,3,0,0,1,3,3v9a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0Z",
    transform: "translate(34 1023)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3,1.944,1.766,4H4.234L3,1.944M3,.236a.248.248,0,0,1,.214.121L5.773,4.621A.25.25,0,0,1,5.558,5H.442a.25.25,0,0,1-.214-.379L2.786.357A.248.248,0,0,1,3,.236Z",
    transform: "translate(46.5 1027.5) rotate(90)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.f8c2ad8036093ba99e60123d920ffe18.svg";
export { ForwardRef as ReactComponent };